import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Stack,
  styled,
} from "@mui/material";
import { COLOR_CONSTANTS } from "@/helpers/Colors";
import type { PaymentStatusCounts } from "../types/common";
import { getPaymentSidebarFilters } from "../constants/sidebarFilters";

const CustomListItem = styled(ListItemButton)`
  &&.Mui-selected {
    color: ${COLOR_CONSTANTS["on-primary/variant"]};
    background-color: ${COLOR_CONSTANTS["primary/variant"]};
  }
`;

interface PaymentStatusFilterSidebarProps {
  statusCounts: PaymentStatusCounts;
  totalCount: number;
  selectedStatus: string | null;
  onStatusChange: (status: string | null) => void;
}

export default function PaymentStatusFilterSidebar({
  statusCounts,
  totalCount,
  selectedStatus,
  onStatusChange,
}: PaymentStatusFilterSidebarProps) {
  const filters = getPaymentSidebarFilters();

  return (
    <Box
      sx={{
        width: 250,
        bgcolor: "background.paper",
        borderRadius: "8px",
        flexShrink: 0,
        maxHeight: "calc(100vh - 180px)",
        overflowY: "auto",
      }}
    >
      <List component="nav">
        <ListSubheader>PAYMENTS</ListSubheader>
        <Divider />
        {filters.map((filter) => {
          const count = filter.status
            ? filter.paymentStatuses.reduce((sum, ps) => sum + (statusCounts[ps] ?? 0), 0)
            : totalCount;

          return (
            <CustomListItem
              key={filter.label}
              selected={selectedStatus === filter.status}
              onClick={() => onStatusChange(filter.status)}
            >
              <ListItemText
                primary={
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <div>{filter.label}</div>
                    <div>{count}</div>
                  </Stack>
                }
              />
            </CustomListItem>
          );
        })}
      </List>
    </Box>
  );
}
